import PayUSecureForm, { PayUSpecificSecureFormProps } from '../PayUSecureForm/PayUSecureForm';

const PayUDateSecureForm = (props: PayUSpecificSecureFormProps) => (
    <PayUSecureForm formType="date" {...props} />
);

export default PayUDateSecureForm;
